<template>
  <div class="wrapper">
    <div class="searchPage">
      <div class="searchlist-t">
        <div class="searchlist-tl" @click="sort(1)" :class="currentindex == 1 ? 'active' : ''"><span>默认</span></div>
        <div class="searchlist-tl" @click="sort(2)" :class="currentindex == 2 ? 'active' : ''"><span>最新</span></div>
        <!-- <div class="searchlist-tl" @click="sort(3)" :class="currentindex==3?'active':''">
          <span>销量</span>
          <img src="../../assets/images/search/icon1.svg" alt v-if="currentindex!=3">
          <img src="../../assets/images/search/icon2.svg" alt v-if="currentindex==3&&sortOrder=='2'">
          <img src="../../assets/images/search/icon3.svg" alt v-if="currentindex==3&&sortOrder=='1'">
        </div> -->
        <div class="searchlist-tl" @click="sort(4)" :class="currentindex == 4 ? 'active' : ''">
          <span>价格</span>
          <img src="../../assets/images/search/icon1.svg" alt v-if="currentindex != 4">
          <img src="../../assets/images/search/icon2.svg" alt v-if="currentindex == 4 && sortOrder == '2'">
          <img src="../../assets/images/search/icon3.svg" alt v-if="currentindex == 4 && sortOrder == '1'">
        </div>
        <div class="searchlist-tlr" @click="vary">
          <img :src="require(`../../assets/images/search/change${style}.svg`)" alt="">
        </div>
      </div>
    </div>
    <div class="home-content-tab">
      <van-list class="tabbox" v-model="loading" :finished="finished" @load="loadMore" :offset="20" id="scroll">
        <van-pull-refresh v-model="isLoading" @refresh="refresh">
          <div :class="style == 1 ? 'refresh1' : 'refresh'">
            <img @click="toAreaCoupon" class="areaImg" :src="coupon_image" alt="" v-if="coupon_image" />
            <div v-if="big == '1'" class="areaBox">
              <div v-for="(item, index) in areaList" :key="index" @click="changeNbr(item.nbr)"
                :class="{ areaItem: true, active: item.nbr == nbr }">
                <p class="areaItemTitle">{{ item.title }}</p>
                <p class="areaItemDesc">{{ item.description }}</p>
              </div>
            </div>
            <div class="tabboxm" v-for="(item, index) in goods_list" :key="index"
              @click="golistdetail(item.nbr, item.rule_type)">
              <div class="tabboxmt">
                <img v-lazy="item.commodity_logo + `${imgCrop}resize,w_500`" alt />
                <div :class="item.quantity === '0' ? 'noNum' : 'noNum hide'">
                  <img v-lazy="require('../../assets/images/noNum.png')" alt />
                </div>
              </div>
              <div class="right">
                <div class="bottomArea" v-if="style == 2">
                  <img v-if="item.start_state == 0" class="beSale" src="../../assets/images/beSale.png" alt="">
                </div>
                <div class="right-top">
                  <div class="tanboxmm1 sigle-h">{{ item.commodity_name }}</div>
                  <div :class="item.is_use_coupon == '0' ? 'tanboxmbb hide' : 'tanboxmbb'" v-if="style == 1">
                    <span>可使用优惠券</span>
                    <div class="bottomArea">
                      <img v-if="item.start_state == 0" class="beSale" src="../../assets/images/beSale.png" alt="">
                    </div>
                  </div>
                  <div>
                  <div class="commoditySummary sigle-h" :style="item.commodity_summary ? { background: '#FFF0B0' } : { background: 'transparent' }">
                    {{ item.commodity_summary }}</div>
                  </div>
                  <div class="commoditySummarySales sigle-h"> 已抢{{ item.show_sales_num }}件</div>
                </div>
                <div class="right-bottom">
                  <div class="tanboxmb">
                    <span v-if="item.rule_type == '2'">
                      <i>￥</i>{{ roleNewText.toLocaleLowerCase() == 'sell' && item.show_price ? item.show_price : item[`min_${roleNewText}_price`] }}
                    </span>
                    <span v-else>
                      <i>￥</i>{{ roleText.toLocaleLowerCase() == 'sell' && item.show_price ? item.show_price : item[`min_${roleText}_price`] }}
                    </span>
                    <span v-if="parseFloat((item[`min_sell_price`] - item[`min_${roleText}_price`]).toFixed(2)) != 0">
                      <!--/<i> 赚￥</i>{{parseFloat((item[`min_sell_price`]-item[`min_${roleText}_price`]).toFixed(2))}}-->
                    </span>
                    <div class="tanboxmbbb">￥{{ item.old_price }}</div>
                    <div v-if="style == 2" :class="item.is_use_coupon == '0' ? 'tanboxmbb hide' : 'tanboxmbb'">可用券</div>
                  </div>
                </div>
                <!-- <div class="tanboxmm2 more-h" style=" -webkit-box-orient: vertical;">
                      {{item.describe}}
                  </div>-->
              </div>
            </div>
            <div class="nomore" v-show="finished == true && goods_list.length != 0">没有更多了^v^</div>
          </div>
        </van-pull-refresh>
      </van-list>
    </div>
    <div class="noList">

    </div>
    <!-- 分享按钮 -->
    <div class="poBtnArea">
      <div class="share" @click="share" v-if="backImg">
        <img src="../../assets/images/share_button.png" />
        <p>分享</p>
      </div>
      <div class="toTop" @click="toTopAnimate" v-show="toTopShow">
        <img src="../../assets/images/index/top.svg" />
      </div>
    </div>

    <!-- 分享图 -->
    <div class="box">
      <van-popup v-model="shareShow">
        <div>
          <img :src="htmlUrl" alt="" class="swiper-showImg">
        </div>
      </van-popup>
      <div class="hold" v-if="shareShow">
        <div @click="wechatShareBtn1">
          <img src="../../assets/images/Sharing_Friends.png" /><br />
          <span>分享好友</span>
        </div>
        <div @click="wechatShareBtn2">
          <img src="../../assets/images/Sharing_Friends2.png" /><br />
          <span>分享朋友圈</span>
        </div>
        <div @click="downloadImg">
          <img src="../../assets/images/Save_pictures.png" /><br />
          <a :dowanload="htmlUrl">下载图片</a>
        </div>
      </div>
    </div>

    <div class="homeBtn" @click.stop="toHome">
      <span>回首页</span>
    </div>
  </div>
</template>

<script>
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      //first_classify: [],
      big: '',
      nbr: "", // 专区nbr
      areaList: [],
      goods_list: [], //商品
      //classifyindexid: "", //下标id
      loading: false, //上拉加载
      finished: false, //加载完成
      pageIndex: 0,
      canAdd: false,
      numPerPage: 10,
      roleText: "sell",
      roleNewText: "sell",
      keepAlive: true,
      isLoading: false,
      scroll: 0,
      active: 0,
      title: "",
      toTopShow: false,
      currentindex: "1",
      style: "2",
      sortType: "0",
      sortOrder: "1",
      isLogin: 0,
      option: {},
      shareShow: false,
      htmlUrl: '',
      info: {},
      qrCode: '',
      backImg: '',
      coupon_image: '',
      showHome: false,
    };
  },
  watch: {
    $route(to, from) {
      if (
        from.path == "/information" ||
        from.path == "/placeorder" ||
        from.path == "/index"
      ) {
        this.keepAlive = true;
      } else {
        this.keepAlive = false;
      }
    }
  },
  computed: {
  },
  methods: {
    toHome() {
      this.$router.replace({
        path: "/index",
      });
    },
    toAreaCoupon() {
      this.$router.push({ path: "/areaCoupon", query: { nbr: this.nbr, supNbr: this.userInfo.nbr } });
    },
    share() {
      if (this.htmlUrl) {
        this.shareShow = true
      } else if (this.qrCode) {
        this.shareImage()
      } else {
        this.createCode();
        this.codeTimer = setInterval(() => {
          this.createCode();
        }, 5000);
      }
    },
    shareImage() {
      let that = this
      let toast = that.$toast.loading({ message: '生成分享图' })
      that.$post("/api/image/share/generateAreaShareImage", {
        backgroundUrl: that.backImg,
        codeUrl: that.qrCode,
        username: that.info.nick_name,
        userHeadUrl: that.info.head_pic,
      }).then(res => {
        let resp = res.object.resp;
        if (res.code == "200") {
          if (resp.resp_code == "0" && resp.resp_result == "0") {
            that.htmlUrl = resp.imageUrl;
            that.shareShow = true
          }
        }
        toast.clear()
      }).catch(err => {
        toast.clear()
      });
    },
    createCode() {
      let that = this;
      let toast = that.$toast.loading({ message: '生成二维码' })
      that.$post("/api/wechat/gzh/generateNewQRCode", {
        page: '/explosive',
        nbr: that.$route.query.nbr || '',
        supNbr: this.userInfo.nbr,
        big: this.big,
      }).then(res => {
        let resp = res.object.resp;
        if (res.code == "200") {
          if (resp.resp_code == "0" && resp.resp_result == "0") {
            that.qrCode = resp.qrcode;
            clearInterval(that.codeTimer);
            that.shareImage()
          }
        }
        toast.clear()
      }).catch(err => {
        toast.clear()
      });
    },
    // 下载提示
    downloadImg() {
      this.$toast({
        message: '请长按保存图片',
        duration: 2000
      });
    },
    // 分享朋友
    wechatShareBtn1() {
      this.$toast({
        message: '请点击右上角进行分享',
        duration: 2000
      });
    },
    // 分享朋友圈
    wechatShareBtn2() {
      this.$toast({
        message: '请点击右上角进行分享',
        duration: 2000
      });
    },
    checkOption() {
      if (!(this.userInfo && this.userInfo.nbr)) {
        this.isLogin = 0;
        this.roleText = 'sell';
        this.roleNewText = 'sell';
      } else {
        this.isLogin = 1;
        this.getUserInfo();
      }
      this.option.title && this.goods_list.length > 0 && this.weChatShare(this.option);
    },
    vary() {
      if (this.style == 2) {
        this.style = 1;
      } else {
        this.style = 2;
      }
    },
    changeNbr(nbr) {
      if (this.nbr == nbr) return false
      this.nbr = nbr
      this.pageIndex = 0;
      this.getData([]);
    },
    refresh() {
      this.finished = true;
      this.pageIndex = 0;
      this.getData([]);
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    golistdetail(nbr, rule_type) {
      if (rule_type == '2') {
        this.$router.push({ path: "/sourceListdetail", query: { nbr: nbr, supNbr: this.userInfo.nbr } });
      } else {
        this.$router.push({ path: "/listdetail", query: { nbr: nbr, supNbr: this.userInfo.nbr } });
      }
    },
    loadMore() {
      if (this.finished) {
        return false;
      }
      if (this.canAdd) {
        this.loading = true;
        this.pageIndex++;
        this.getData(this.goods_list);
      }
    },
    sort(index) {
      this.finished = false;
      let currentindex = this.currentindex;
      let sortType = this.sortType,
        sortOrder = this.sortOrder;
      switch (index) {
        case 1:
          sortType = "0";
          sortOrder = "1";
          break;
        case 2:
          sortType = "3";
          sortOrder = "2";
          break;
        case 3:
          sortType = "2";
          if (currentindex != index) {
            sortOrder = "2";
          } else {
            sortOrder = sortOrder == "2" ? "1" : "2";
          }
          break;
        case 4:
          sortType = "1";
          if (currentindex != index) {
            sortOrder = "1";
          } else {
            sortOrder = sortOrder == "1" ? "2" : "1";
          }
          break;
        default:
          sortType = "0";
          sortOrder = "1";
      }

      this.currentindex = index;
      this.sortType = sortType;
      this.sortOrder = sortOrder;
      this.pageIndex = 0;
      this.goods_list = [];
      this.getData([]);
    },
    getData(oldList) {
      let that = this
      // this.goods_list = oldList;
      this.$commonPost({
        jydm: "flow_70013",
        flow_70013: {
          area_nbr: this.nbr,
          sort_type: this.sortType,
          sort_order: this.sortOrder,
          page_index: this.pageIndex * this.numPerPage,
          num_per_page: this.numPerPage,
          parent_nbr: "",
          type: -1
        }
      })
        .then(response => {
          let arr = [];
          if (response.commodity) {
            if (response.commodity.length > 0) {
              arr = response.commodity;
            } else {
              arr.push(response.commodity);
            }
          }
          this.coupon_image = response.coupon_image
          if (this.pageIndex == 0 && !this.big) {
            that.option = {
              title: response.share_title || response.area_title,
              desc: response.share_desc || '',
              link: `${location.origin}/explosive?nbr=${this.$route.query.nbr || ''}&supNbr=${this.userInfo.nbr}`,
              images: response.share_image || response.image_path,
            }
            setTimeout(() => {
              that.weChatShare(that.option);
            }, 500)
          }
          this.goods_list = oldList.concat(arr);
          this.canAdd = arr.length >= this.numPerPage;
          this.loading = false;
          if (!this.big) {
            this.title = response.area_title;
            this.backImg = response.share_image_base;
            document.title = response.area_title;
          }
          if (arr.length < this.numPerPage) {
            this.finished = true;
          } else {
            this.finished = false;
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    handleScroll() {
      // 设备/屏幕高度
      let scrollTop = document.getElementById("scroll").scrollTop;
      if (scrollTop > 50) {
        this.toTopShow = true;
      } else {
        this.toTopShow = false;
      }
    },
    // 回到顶部动画
    toTopAnimate() {
      document.getElementById("scroll").scrollTop = 0;
    },
    getUserInfo() {
      // 用户的基本信息(身份)
      this.$commonPost({
        jydm: "flow_10003",
        flow_10003: {
          user_nbr: this.userInfo.nbr
        }
      })
        .then(response => {
          this.info = response;
          if (response.role == 0 || response.role == 1) {
            this.roleText = "sell";
          } else if (response.role == 2) {
            this.roleText = "agent";
          } else if (response.role == 3) {
            this.roleText = "director";
          }

          if (response.new_role == 0 || response.new_role == 1) {
            this.roleNewText = "sell";
          } else if (response.new_role == 2) {
            this.roleNewText = "agent";
          } else if (response.new_role == 3) {
            this.roleNewText = "director";
          }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getAreaList(areaNbr) {
      let that = this
      this.$commonPost({
        jydm: "flow_70246",
        flow_70246: {
          area_nbr: areaNbr,
          page_index: 0,
          num_per_page: 100,
        }
      })
        .then(response => {
          let arr = [];
          if (response.list) {
            if (response.list.length > 0) {
              arr = response.list;
            } else {
              arr.push(response.list);
            }
          }
          this.areaList = arr
          if (arr.length > 0) {
            this.nbr = arr[0].nbr
            this.pageIndex = 0;
            this.goods_list = [];
            this.getData([]);
          }
          this.title = response.title;
          this.backImg = response.share_image_base;
          document.title = response.title;
          that.option = {
            title: response.share_title || response.title,
            desc: response.share_desc || '',
            link: `${location.origin}/explosive?nbr=${this.$route.query.nbr || ''}&big=1&supNbr=${this.userInfo.nbr}`,
            images: response.share_image || response.image_path,
          }
          setTimeout(() => {
            that.weChatShare(that.option);
          }, 500)
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
  },
  created() {
  },
  mounted() {
  },
  // 被缓存时任执行
  activated() {
    document.getElementById("scroll").addEventListener('scroll', this.handleScroll, true);
    document.title = this.title;
    if (!this.keepAlive) {
      //将高度滚动到原来离开页面的高度
      document.getElementById("scroll").scrollTop = this.scroll;
      return false;
    } else {
      let that = this;
      this.pageIndex = 0;
      this.qrCode = '';
      this.htmlUrl = '';
      this.big = this.$route.query.big || '';
      if (this.big == '1') {
        this.getAreaList(this.$route.query.nbr)
      } else {
        this.nbr = this.$route.query.nbr;
        this.goods_list = [];
        this.getData([]);
      }
    }
    this.checkOption();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == '/login') {
        vm.showHome = true
      } else {
        vm.showHome = false
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    this.scroll = document.getElementById("scroll").scrollTop;
    document.getElementById("scroll").removeEventListener('scroll', this.handleScroll, true);
    next();
  }
};
</script>
<style scoped lang='stylus'></style>
<style scoped lang='less'>
.box .van-popup {
  background: none;
  top: 38%;

  img {
    width: 65vw;
    height: 115.6vw;
    object-fit: cover;
    background: #ccc;
  }
}

.hold {
  width: 100%;
  height: 2.48rem;
  background: #FFFFFF;
  border-top-left-radius: .1rem;
  border-top-right-radius: .1rem;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 999999;
  display: flex;
}

.hold div {
  width: 2.5rem;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.hold img {
  width: 1.2rem;
  height: 1.2rem;
  margin-top: 0.33rem;
  margin-bottom: 0.2rem;
}

.searchPage {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;

  .scroll {
    height: calc(100vh - 1.56rem);
    overflow-y: scroll;
    width: 100%;
  }

  .scroll::-webkit-scrollbar {
    display: none;
  }
}

.searchlist-t {
  position: fixed;
  top: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 0.28rem;
  z-index: 9;
  background: #fff;
  width: 100%;
  height: .68rem;
}

.searchlist-tl {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999;
  transform: scale(0.5);

  img {
    width: .28rem;
    height: .36rem;
    margin-left: .08rem;
  }

  span {
    line-height: .68rem;
    font-size: 0.48rem;
  }

}

.searchlist-tlr {
  width: 0.78rem;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 0.3rem;
    height: 0.3rem;
  }
}

.searchlist-tl.active {
  font-weight: 700;
  color: #333 !important;
}

.poBtnArea {
  position: fixed;
  left: 6.08rem;
  z-index: 999;
  bottom: 2rem;
  text-align: right;
}

.toTop {
  width: .8rem;
  height: 0.8rem;
  margin-top: .3rem;
  background: rgba(51, 51, 51, 0.5);
  text-align: center;
  line-height: .8rem;
  border-radius: 50%;
  display: inline-block;
}

.toTop img {
  width: 0.4rem;
  height: 0.4rem;
}

.share {
  width: 1.22rem;
  height: 1.22rem;
  bottom: 1.78rem;
  border-radius: 50%;
  background: rgba(51, 51, 51, 0.90);
  border: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #E8B86B;
  font-size: 0.24rem;
}

.share p {
  width: 1.22rem;
  font-size: 0.24rem;
  color: #E8B86B;
  text-align: center;
  line-height: 1;
}

.share img {
  width: .41rem;
  height: .42rem;
  margin-bottom: .1rem;
}

.hide {
  display: none !important;
}

.wrapper {
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
}

.tabbox {
  height: 100vh;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  width: 100%;
}

.areaBox {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding-left: .22rem;
}

.areaItem {
  width: 2.2rem;
  height: 1.02rem;
  border: 1px solid #B9B9B9;
  box-sizing: border-box;
  padding-top: .18rem;
  border-radius: .1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: .22rem;
  margin-right: .22rem;

  .areaItemTitle {
    height: .34rem;
    line-height: .34rem;
    color: #333;
    font-size: .24rem;
    font-weight: bold;
  }

  .areaItemDesc {
    width: 2rem;
    height: .28rem;
    line-height: .28rem;
    margin-top: .06rem;
    color: #999;
    font-size: .2rem;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: nowrap;
  }
}

.areaItem.active {
  background: #F98405;
  border: 1px solid #F98405;

  .areaItemTitle {
    color: #fff;
  }

  .areaItemDesc {
    color: #fff;
  }
}

.refresh {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  background: #fff;

  .tabboxm:nth-of-type(2n) {
    margin-left: 0.18rem;
  }

  .tabboxm:nth-of-type(2n + 1) {
    margin-left: 0.23rem;
  }

  .tabboxm {
    margin-top: 0.24rem;
    width: 3.43rem;
    height: 6.2rem;
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    border-radius: 0.16rem;
    position: relative;
    overflow: hidden;

    .tabboxmt {
      width: 100%;
      height: 3.42rem;
      box-sizing: border-box;
      border-bottom: 1px solid #ddd;
      position: relative;
      overflow: hidden;

      .noNum {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        background: rgba(51, 51, 51, 0.3);
        width: 100%;
        height: 3.42rem;

        img {
          width: 75%;
          height: 60%;
        }
      }

      img {
        width: 100%;
        height: 3.42rem;
        object-fit: cover;
      }
    }

    .tanboxmm1 {
      line-height: 0.32rem;
      margin: 0 0.1rem;
      font-size: 0.24rem;
      margin-top: 0.22rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
      white-space: normal;
      height: 0.62rem;
    }

    .tanboxmb {
      margin-top: 0.15rem;
      line-height: 0.4rem;
      overflow: hidden;

      span i {
        font-size: 0.24rem;
        font-weight: bold;
      }

      span:nth-of-type(1) {
        color: #333333;
        font-size: 0.3rem;
        margin-left: 0.1rem;
        font-weight: bold;
      }

      span:nth-of-type(2) {
        color: #E52B25;
        font-size: 0.24rem;
        font-weight: bold;
      }
    }

    .tanboxmbbb {
      color: #666;
      margin-left: 0.1rem;
      font-size: 0.24rem;
      text-decoration: line-through;
      line-height: 0.34rem;
      margin-top: 0.02rem;
    }

    .tanboxmbb {
      width: 0.9rem;
      height: 0.31rem;
      color: #f53547;
      font-size: 0.2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background: url(../../assets/images/FFF1F2.png) no-repeat;
      background-size: 0.9rem 0.3rem;
      position: absolute;
      right: 0;
      bottom: 0.14rem;
    }

    .bottomArea {
      position: relative;

      .beSale {
        width: 1.16rem;
        height: .3rem;
        position: absolute;
        top: -0.36rem;
        left: 0.1rem;
      }
    }

    .commoditySummary {
      max-width: 3rem;
      color: #FF3500;
      font-size: 0.2rem;
      font-weight: 500;
      line-height: 1.5;
      height: 0.26rem;
      margin: 0.12rem .1rem 0;
      background: #FFF0B0;
      padding: 0.04rem 0.1rem;
      border-radius: 0.04rem;
      display: inline-block;
    }
    .commoditySummarySales {
      max-width: 3rem;
      color: #0074FF;
      font-size: 0.2rem;
      font-weight: 500;
      line-height: 1.5;
      height: 0.26rem;
      margin: 0.12rem .1rem 0;
      background: #EEF7FF;
      padding: 0.04rem 0.1rem;
      border-radius: 0.04rem;
      display: inline-block;
    }
  }
}

.refresh1 {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #fff;

  .tabboxm {
    margin: 0;
    width: 100%;
    height: 3.4rem;
    padding: .2rem .24rem;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;

    .tabboxmt {
      position: relative;

      .noNum {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        background: rgba(51, 51, 51, 0.3);
        width: 100%;
        height: 2rem;
        border-radius: .08rem;

        img {
          width: 75%;
          height: 60%;
        }
      }

      img {
        width: 2.4rem;
        height: 2.4rem;
        border-radius: .08rem;
      }
    }

    .commoditySummary {
      color: #FF3500;
      font-size: 0.2rem;
      font-weight: 500;
      margin: 0.12rem 0 0;
      background: #FFF0B0;
      padding: 0.04rem 0.1rem;
      border-radius: 0.04rem;
      display: inline-block;
      height: 0.26rem;
      max-width: 4.3rem;
      line-height: 1.5;
    }
    .commoditySummarySales {
      max-width: 3rem;
      color: #0074FF;
      font-size: 0.2rem;
      font-weight: 500;
      line-height: 1.5;
      height: 0.26rem;
      margin: 0.12rem .1rem 0;
      background: #EEF7FF;
      padding: 0.04rem 0.1rem;
      border-radius: 0.04rem;
      display: inline-block;
    }

    .right {
      width: calc(100% - 2.6rem);
      display: flex;
      flex-direction: column;
      justify-content: start;
      height: 100%;
      position: relative;

      .bottomArea {
        margin-left: 0.1rem;

        .beSale {
          width: 1.16rem;
          height: 0.3rem;
        }
      }

      .right-top {
        .tanboxmm1 {
          line-height: 0.32rem;
          height: .64rem;
          font-size: 0.24rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-all;
          white-space: normal;
        }

        .tanboxmbb {
          margin-top: 0.18rem;
          height: 0.3rem;
          line-height: 0.3rem;
          display: flex;
          align-items: center;
          border-radius: .04rem;
          margin-right: .14rem;

          span {
            background: #FFF1F2;
            font-size: .2rem;
            color: #F53547;
            line-height: 0.3rem;
            padding: 0 0.12rem;
          }
        }
      }

      .right-bottom {
        margin-top: 0.1rem;

        .tanboxmb {
          line-height: 0.4rem;
          overflow: hidden;

          span i {
            font-size: 0.2rem;
            font-weight: bold;
          }

          span:nth-of-type(1) {
            color: #333333;
            font-size: 0.3rem;
            font-weight: bold;
          }

          span:nth-of-type(2) {
            color: #E52B25;
            font-size: 0.24rem;
            font-weight: bold;
          }
        }

        .tanboxmbbb {
          color: #666;
          font-size: 0.24rem;
          text-decoration: line-through;
          line-height: 0.34rem;
          margin-top: 0.03rem;
        }
      }
    }
  }
}

.home-content-tab {
  position: fixed;
  top: 0.7rem;
  width: 100%;
}

.home-content-tabtop {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
}

.home-content-tabtop::-webkit-scrollbar {
  display: none;
}

.home-content-tabtopm {
  width: 1.08rem;
  height: 0.56rem;
  font-size: 0.28rem;
  line-height: 0.56rem;
  text-align: center;
}




.tanboxmm2 {
  line-height: 0.32rem;
  margin: 0 0.24rem;
  margin-top: 0.15rem;
  font-size: 0.22rem;
  color: #999;
}

.areaImg {
  width: 7.02rem;
  height: 1.7rem;
  margin: .1rem auto;
  object-fit: cover;
}


.nomore {
  width: 100%;
  text-align: center;
  color: #999999;
  line-height: 1rem;
  display: block;
}

.homeBtn {
  position: fixed;
  left: .24rem;
  bottom: 2rem;
  z-index: 999;
  width: .8rem;
  height: .8rem;
  border-radius: .4rem;
  box-sizing: border-box;
  background: rgba(51, 51, 51, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    font-size: .24rem;
    color: #fff;
  }
}
</style>
<style lang="stylus" scoped>
.home-content-tab >>> .van-tabs__line {
  background-color: #5045D8 !important;
}
.home-content-tab >>> .van-pull-refresh{
  padding-bottom: .8rem;
  box-sizing:border-box;
  min-height: 100vh;
}
.home-content-tab >>> .van-tab--active {
  color: #5045D8 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/index/explosive.vue